<template>

    <form autocomplete="off" class="pl-3" v-on:submit.prevent="close" v-show="loaded">
        <div v-for="category in categories" :key="category.id">
            <trax-ui-choice v-model="form.indicators[category.uuid]" :options="indicator_select"
                size="xs" plain-icons="1" class="float-left" allow-unselect="1" style="position:relative;top:-3px;">
            </trax-ui-choice>
            <p style="padding-left:35px;font-size:1rem;">{{ category.name }}</p>
        </div>

        <h5 class="font-weight-bold mt-4">{{ lang.polaris.dashboard.comments }}</h5>
        <trax-ui-input v-model="form.comments" :error="errors.comments" rows="5">
        </trax-ui-input>

        <div class="trax-form-actions text-center">
            <button type="submit" class="btn btn-default btn-round"> {{ lang.polaris.form.close }} </button>
        </div>
    </form>
    
</template>

<script>
    export default {

        props: {
            id: {default: 'enac-procedure-atp-daf-edit-competencies-select'},
            bus: null
        },
    
        data: function() {
            return {
                lang: lang,
                endpoint: app_url+'polaris/api/front/competency-items',
                loaded: false,
                competency_indexes: data.competency_indexes,
                form: {
                    comments: '',
                    indicators: {}
                },
                indicator_select: [
                    {value: 1, icon: 'error_outline', color: 'danger'}
                ],
                errors: {},
                typeCode: null,
                categories: {}
            }
        },

        computed: {

            competencyIndexId: function() {
                return this.competency_indexes['general-criteria'];
            }
        },

        created: function() {
            this.bus.$on(this.id+'-open', this.initData);
        },

        watch: {
            
            form: function() {
                if (this.loaded) this.setState();
            }
        },

        methods: {

            initData(titleAndData) {
                this.loaded = false,
                this.errors = {};
                this.typeCode = titleAndData.data.type_code;
                this.form = titleAndData.data.states;
                if (this.typeCode == 'theoretical-training') this.addData();
                else this.loadData();
            },
            
            loadData() {
                var that = this;
                axios.get(this.endpoint, {
                    params: {
                        filters: {
                            type: that.typeCode,
                            index_id: that.competencyIndexId,
                            parent_id: { $exists: false }
                        },
                        relations: ['children'],
                        sort: ['order']
                    }})
                    .then(function (response) {
                        that.categories = response.data.data;
                        that.loaded = true;
                        that.setState();
                    })
                    .catch(function (error) {
                    });
            },
            
            addData() {
                this.categories = [
                    {id: 'progress-check', uuid: 'progress-check', name: lang.polaris.procedure.progress_check},
                    {id: 'certificate-test', uuid: 'certificate-test', name: lang.polaris.procedure.certificate_test},
                ];
                this.loaded = true;
                this.setState();
            },
            
            setState() {
                this.bus.$emit(this.id+'-set', {type_code: this.typeCode, states: this.form, indicators: this.indicatorNames()});
            },

            close() {
                this.bus.$emit(this.id+'-close');
            },

            indicatorNames() {
                var indicators = {};
                for (var index in this.categories) {
                    var item = this.categories[index];
                    indicators[item.uuid] = item.name;
                }
                return indicators;
            }
        }

    }
</script>
